import { getSectionDetails } from 'modules/settings/pods/settings-devices/settings-devices-configuration/service/settings-devices-configuration.service';
import { DeviceLayoutConfigSectionDetails } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';

const inFlightSectionRequestMap = new Map<string, Promise<DeviceLayoutConfigSectionDetails>>();

export const requestSectionDetails = (
    layoutId: string,
    sectionId: string
): Promise<DeviceLayoutConfigSectionDetails> => {
    const requestKey = `${layoutId}:${sectionId}`;

    if (!inFlightSectionRequestMap.has(requestKey)) {
        inFlightSectionRequestMap.set(
            requestKey,
            getSectionDetails(layoutId, sectionId).finally(() => {
                inFlightSectionRequestMap.delete(requestKey);
            })
        );
    }

    return inFlightSectionRequestMap.get(requestKey)!;
};
